import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';

const StyledLabel = styled.div`
 display: inline-flex;
 align-items: center;
 margin: 5px 0;
 `;

const EnergyLink = styled.a`
  cursor: pointer;
  text-decoration: none;
`;

const FicheLink = styled.a`
  text-decoration: none;
  padding-left: 10px;
  color: ${(props) => props.theme.colors.primary.purple};
  &:hover {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.primary.purple};
  }
  &:focus, &:active {
    outline: 0;
    color: ${(props) => props.theme.colors.primary.purple};
  }
`;

const EnergyLabel = ({
  labelSrc, labelLink, ficheTitle, ficheLink
}) => (
  <EnvironmentThemeProvider>
    <StyledLabel>
      <EnergyLink href={labelLink}>
        <div dangerouslySetInnerHTML={{ __html: labelSrc }} />
      </EnergyLink>
      <FicheLink href={ficheLink}>
        {ficheTitle}
      </FicheLink>
    </StyledLabel>
  </EnvironmentThemeProvider>
);

EnergyLabel.displayName = 'EnergyLabel';

EnergyLabel.propTypes = {
  labelSrc: PropTypes.string.isRequired,
  labelLink: PropTypes.string.isRequired,
  ficheTitle: PropTypes.string.isRequired,
  ficheLink: PropTypes.string.isRequired
};

export default EnergyLabel;
